import React, {Component} from 'react'
import {api} from "../../service/api.service";
import {extendObservable} from "mobx";
import receiptsStore from "../../store/receipts.store";
import withRouter from "../../components/withRouter";
import LoadingPageOverlay from "../../components/LoadingPageOverlay";
import {observer} from "mobx-react";
import ReceiptInspectionForm from "./ReceiptInspectionForm";
import { Alert } from 'antd';
import t from "../../service/translate.service";

class ReceiptInspectionPreview extends Component {
  constructor(props) {
    super(props)

    extendObservable(this, {
      loading: false,
      error: false,
      document: null
    })
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    this.setDocument();
  }

  async getDocument(docName, contractNumber, docId, caseNumber, year) {
    try {
      if (!receiptsStore?.selectedContractData) {
        this.props.navigate('/receipt-inspection')
      }
      this.error = false
      const res = await api.get(`/receipts/${docName}/${contractNumber}/documents`, {
        params: {
          docId,
          caseNumber,
          year
        },
        responseType: 'blob',
      })
      return res.data
    } catch (err) {
      this.error = true
    }
  }

  setDocument = async () => {
    this.loading = true;
    const { docName, contractNumber, docId, caseNumber, year } = this.props.useParams;
    this.document = await this.getDocument(docName, contractNumber, docId, caseNumber, year);
    this.loading = false;
  }

  render() {
    if (this.loading) {
      return (<LoadingPageOverlay/>)
    }
    return (
      <div>
        {this.error && (
          <Alert
            message={t.SOMETHING_WENT_WRONG}
            type="error"
            style={{ marginTop: "12px", marginBottom: "12px" }}
            role="alert"
            aria-live="assertive"
          />
        )}
        <div className="position-relative" style={{ minHeight: "900px" }}>
          <div className="document-preview">
            <button
              className="close-preview"
              onClick={() => this.props.navigate("/receipt-inspection")}
              aria-label={t.CLOSE_PREVIEW}
            >
              ×
            </button>
            <div style={{ paddingLeft: "20px", paddingRight: "20px" }} className="text-center">
              {this.document && (
                <iframe
                  src={URL.createObjectURL(this.document)}
                  sandbox
                  title={t.DOCUMENT_PREVIEW}
                  aria-label={t.DOCUMENT_PREVIEW}
                  style={{ width: "100%", height: "600px", border: "none" }}
                />
              )}
            </div>
          </div>
        </div>
        <ReceiptInspectionForm contractData={receiptsStore.selectedContractData} />
      </div>
    );
  }
}

export default withRouter(observer(ReceiptInspectionPreview))